import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import "./App.css";

import Mainpage from "./Homepage/Homepage";
import ServicesPage from "./Servicespage/Servicespage";
import AboutUsPage from "./AboutUspage/AboutUspage";
import ContactPage from "./ContactPage/ContactPage";
import ProductPage from "./Product/ProductPage";
import Page404 from "./Page404/Page404";
class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={Mainpage} />
          <Route exact path="/contactus" component={ContactPage} />
          <Route exact path="/about" component={AboutUsPage} />
          <Route exact path="/home" component={Mainpage} />
          <Route exact path="/services" component={ServicesPage} />
          <Route exact path="/product" component={ProductPage} />
          <Route component={Page404} />
          <Redirect to="/404" />
        </Switch>
      </Router>
    );
  }
}

export default App;
